// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"343dcf6f","177":"de7d5039","470":"c4c2483b","498":"a3e9bd54","787":"d3672ccb","805":"c2edf9d5","879":"4f9bd478","886":"27ed49e1","948":"b2576c21"}[chunkId] + ".chunk.js";
};